import { MissionControl, MissionControlHeader, MissionControlSidebar } from '@vitvio/mission-control';
import { Page, Layout } from '@vitvio/navigation';
import { useDemoFunctionalityContext } from '@vitvio/demo-functionality';

export function MissionControlHome() {
  const { isInDemoMode } = useDemoFunctionalityContext();
  return (
    <Page title="Mission Control">
      <Layout
        topbarHeader={<MissionControlHeader />}
        sidebar={<MissionControlSidebar />}
        isInDemoMode={isInDemoMode}
        appName="platform"
      >
        <MissionControl />
      </Layout>
    </Page>
  );
}
